import { connect } from 'react-redux';
import { getQuoteSolvingMode } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  solvingMode: string;
}

export type InitializedState = StateProps & OwnProps;

export const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const solvingMode = getQuoteSolvingMode(state, tabId);

  return { solvingMode };
};

export const connectInitialized = connect(mapStateToProps);
